import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { MRMValidators } from '@mrm/core'; 
import { ProcessedEntity } from 'app/models/processed-entity.model'; 

export class LOVRevenueRegionBranch {
  branchCode: string = null;
  englishBranchName: string = null;
  frenchBranchName: string = null;
  financialRegionCode: number = null;  
  englishFinancialRegionName: string = null;
  frenchFinancialRegionName: string = null; 
  processedEntities: ProcessedEntity[] = [];

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({ 
      branchCode: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(20)]),
      englishBranchName: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(250)]),
      frenchBranchName: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(250)]), 
      financialRegionCode: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      englishFinancialRegionName: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(250)]),
      frenchFinancialRegionName: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(250)]), 
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }), 
      processedEntities: new FormArray([])
    });


    return form;
  }
}